export * from './trimAndUppercase.module';
export * from './trimAndUppercase.directive';
